export default __webpack_public_path__ + "static/media/CBS_Paramount_logo.53e0e496.png";